import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
/**
 * Generated class for the MomentDatePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'momentDate',
})
export class MomentDatePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, inputString) {
    let formatString = ""
    switch (inputString){
      case ('anotherFullDate'):
        formatString = "dddd MMMM Do, YYYY";
      break;
      case ('fullDate'):
      formatString = "dddd, MMMM D, YYYY";
      break;
      case ('longDate'):
      formatString = "MMMM D, YYYY";
      break;
      case ('mediumDate'):
      formatString = "MMM D, YYYY";
      break;
      case ('shortDate'):
      formatString = "M/D/YYYY";
      break;
      case ('twitterDate'):
      formatString = "hh:mm A - DD MMM YYYY";
      break;
      default:
      formatString = inputString;
    }
    // console.log(value, inputString, formatString)
    return moment(value).format(formatString);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/moment-date/moment-date.ts